import '@convergence/components/dist/components.css';
import { Route, Routes } from 'react-router-dom';
import { RequireAuth } from '../components/RequireAuth';
import { AppLayout } from '../layouts/AppLayout/AppLayout';
import { Home } from './Home';
import { Providers } from './Providers';
import { Analysis } from './Analysis';
import { Files } from './Files';
import { Analyses } from './Analyses';
import { CreateAction } from './CreateAction';

export function App() {
  return (
    <Providers>
      <Routes>
        <Route
          path="/"
          element={
            <RequireAuth>
              <AppLayout />
            </RequireAuth>
          }
        >
          <Route index element={<Home />} />
          <Route path="files" element={<Files />}></Route>
          <Route path="actions/">
            <Route path="create" element={<CreateAction />}></Route>
          </Route>
          <Route path="a/">
            <Route index element={<Analyses />}></Route>
            <Route path=":slug" element={<Analysis />}></Route>
          </Route>
        </Route>
      </Routes>
    </Providers>
  );
}
